<template>
    <div>
        <div v-if="dataIsMobile" class="mb-4">
            <select class="form-control" v-model="selectedNewsCategory" @change="changeNewsCategory">
                <option :value="null">
                    {{ dataTexts.filter_all_categories }}
                </option>
                <option
                    v-for="newsCategory in dataNewsCategories"
                    :key="newsCategory.slug"
                    :value="newsCategory.slug"
                >
                    {{ newsCategory.name }}
                </option>
            </select>
        </div>
        <div v-else class="mb-4 col-lg-9">
            <div class="row">
                <div
                    href="#"
                    class="col-12 col-md rounded-0 btn mb-3 mr-2"
                    @click="selectedNewsCategory = null; changeNewsCategory()"
                    :class="{
                        'btn-dark': !selectedNewsCategory,
                        'btn-danger': selectedNewsCategory,
                    }"
                >
                    {{ dataTexts.filter_all_categories }}
                </div>
                <div
                    v-for="newsCategory in dataNewsCategories"
                    :key="newsCategory.slug"
                    class="col-12 col-md rounded-0 btn mb-3 mr-2"
                    :class="{
                        'btn-dark': selectedNewsCategory == newsCategory.slug,
                        'btn-danger': selectedNewsCategory != newsCategory.slug,
                    }"
                    @click="selectedNewsCategory = newsCategory.slug; changeNewsCategory()"
                >
                    {{ newsCategory.name }}
                </div>
            </div>
        </div>
        <masonry
            :cols="!dataIsMobile ? 3 : dataIsTablet ? 2 : 1"
            :gutter="20"
            tag="div"
            class="post-grid"
        >
            <div
                v-for="(article, $index) in articles"
                :key="$index"
                class="mb-4 item"
                :class="article.news_category.slug"
            >
                <div
                    class="bg-white shadow"
                    v-if="article.news_category.slug == 'general'"
                >
                    <div class="entry-image">
                        <a :href="'news/' + article.slug">
                            <img
                                :src="article.thumbnail"
                                :alt="article.title"
                            />
                        </a>
                    </div>
                    <div class="px-3 pb-3">
                        <div class="entry-title">
                            <h2>
                                <a :href="'news/' + article.slug">
                                    {{ article.title }}
                                </a>
                            </h2>
                        </div>
                        <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class="icon-calendar3"></i>
                                    {{ article.date }}
                                </li>
                                <li>
                                    {{ article.news_category.name }}
                                </li>
                            </ul>
                        </div>
                        <div
                            class="entry-content"
                            v-html="article.description"
                        ></div>
                        <a
                            :href="'news/' + article.slug"
                            class="more-link mt-2"
                            >{{ dataTexts.read_more }}</a
                        >
                    </div>
                </div>
                <div
                    class="bg-white shadow item"
                    v-else-if="article.news_category.slug == 'quick-news'"
                >
                    <div class="entry-image">
                        <img :src="article.thumbnail" :alt="article.title" />
                    </div>
                    <div class="px-3 pb-3">
                        <div class="entry-title">
                            <h2>{{ article.title }}</h2>
                        </div>
                        <div class="entry-meta mb-2">
                            <ul>
                                <li>
                                    <i class="icon-calendar3"></i>
                                    {{ article.date }}
                                </li>
                                <li>
                                    {{ article.news_category.name }}
                                </li>
                            </ul>
                        </div>
                        <div
                            class="entry-content"
                            v-html="article.description"
                        ></div>
                    </div>
                </div>
                <div
                    class="bg-white shadow item"
                    v-else-if="article.news_category.slug == 'show-info'"
                >
                    <div class="entry-image">
                        <img :src="article.thumbnail" :alt="article.title" />
                    </div>
                    <div class="px-3 pb-3">
                        <div class="entry-title">
                            <h2 v-if="article.show_link">
                                <a
                                    v-if="article.show_link"
                                    :href="article.show_link"
                                    target="_blank"
                                >
                                    {{ article.title }}
                                </a>
                            </h2>
                            <h2 v-else>
                                {{ article.title }}
                            </h2>
                        </div>
                        <div class="entry-meta mb-2">
                            <ul class="list">
                                <li>
                                    {{ article.news_category.name }}
                                </li>
                                <li v-if="article.show_date">
                                    <i class="icon-calendar3"></i>
                                    {{ article.show_date }}
                                </li>
                                <li v-if="article.show_location">
                                    <i class="icon-map-marker2"></i>
                                    {{ article.show_location }}
                                </li>
                                <li v-if="article.booth_number">
                                    <i class="icon-shop"></i>
                                    {{ dataTexts.booth }}
                                    {{ article.booth_number }}
                                </li>
                                <li v-if="article.show_link">
                                    <i class="icon-info-circle"></i>
                                    <a
                                        :href="article.show_link"
                                        target="_blank"
                                        class="text-underline"
                                    >
                                        {{ dataTexts.visit_website }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div
                            class="entry-content"
                            v-html="article.description"
                        ></div>
                    </div>
                </div>
                <div
                    class="bg-white shadow item"
                    v-else-if="article.news_category.slug == 'video-news'"
                >
                    <div class="entry-image">
                        <iframe
                            style="min-height: 230px"
                            :src="'https://www.youtube.com/embed/'+article.video_url"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="px-3 pb-3">
                        <div class="entry-title">
                            <h2>{{ article.title }}</h2>
                        </div>
                        <div class="entry-meta mb-2" v-if="article.duration">
                            <ul>
                                <li>
                                    <i class="icon-calendar3"></i>
                                    {{ article.date }}
                                </li>
                                <li>
                                    <i class="icon-time"></i>
                                    {{ article.duration }}
                                </li>
                                <li>{{ article.news_category.name }}</li>
                            </ul>
                        </div>
                        <div
                            class="entry-content"
                            v-html="article.description"
                        ></div>
                    </div>
                </div>
            </div>
        </masonry>
        <infinite-loading
            :identifier="infiniteId"
            spinner="waveDots"
            @infinite="getResult">
            <div slot="no-more">{{dataTexts.loading_no_more_articles}}</div>
            <div slot="no-results">{{ dataTexts.loading_no_articles_found }}</div>
        </infinite-loading>
    </div>
</template>
<script>
import VueMasonry from "vue-masonry-css";
import InfiniteLoading from "vue-infinite-loading";
export default {
    components: {
        "vue-masonry-css": VueMasonry,
        "vue-infinite-loading": InfiniteLoading
    },
    props: [
        "dataIsMobile",
        "dataIsTablet",
        "dataTexts",
        "dataNewsCategories",
        "dataArticles",
    ],
    data() {
        return {
            page: 2,
            articles: this.dataArticles,
            selectedNewsCategory: null,
            infiniteId: +new Date(),
        };
    },
    methods: {
        getResult($state) {
            axios
                .get("/ajax/articles", {
                    params: {
                        page: this.page,
                        news_category: this.selectedNewsCategory,
                    },
                })
                .then((response) => {
                    if (response.data.data.length) {
                        this.page += 1;
                        this.articles.push(...response.data.data);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
        },
        changeNewsCategory() {
            this.page = 1;
            this.articles = [];
            this.infiniteId += 1;
        },
    },
};
</script>
